import { render, staticRenderFns } from "./homeowner-settings-sidebar.vue?vue&type=template&id=1998d158&scoped=true"
import script from "./homeowner-settings-sidebar.vue?vue&type=script&lang=js"
export * from "./homeowner-settings-sidebar.vue?vue&type=script&lang=js"
import style0 from "./homeowner-settings-sidebar.vue?vue&type=style&index=0&id=1998d158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998d158",
  null
  
)

export default component.exports